<template>
  <div>
    <Header></Header>

    <CardsListTag
      :tagId="id"
      :title="tag().name"
    ></CardsListTag>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import CardsListTag from "@/components/CardsListTag.vue";
import store from "@/store";

export default {
  components: {
    Header, CardsListTag
  },
  props: {
    id: { type: Number, default: 0 }
  },
  methods: {
    tag() {
      return this.$store.getters.tag(this.id);
    },
  },
  beforeRouteEnter: async function (to, from, next) {
    await store.dispatch('loadCardsByTag', {tagId: to.params.id});
    next();
  },
  beforeRouteUpdate: async function (to, from, next) {
    await store.dispatch('loadCardsByTag', {tagId: to.params.id});
    next();
  },
};
</script>
